var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../lib/utils";
function Card(_a) {
    var className = _a.className, _b = _a.shadow, shadow = _b === void 0 ? true : _b, _c = _a.rounded, rounded = _c === void 0 ? true : _c, _d = _a.columns, columns = _d === void 0 ? 1 : _d, _e = _a.divide, divide = _e === void 0 ? false : _e, _f = _a.bordered, bordered = _f === void 0 ? true : _f, props = __rest(_a, ["className", "shadow", "rounded", "columns", "divide", "bordered"]);
    // List the possible options so these tailwind classes are included in the build
    var gridColumns = {
        1: "grid-cols-1",
        2: "grid-cols-2",
        3: "grid-cols-3",
        4: "grid-cols-4",
        5: "grid-cols-5",
        6: "grid-cols-6",
        7: "grid-cols-7",
        8: "grid-cols-8",
        9: "grid-cols-9",
        10: "grid-cols-10",
        11: "grid-cols-11",
        12: "grid-cols-12",
    };
    return (_jsx("div", __assign({ "data-slot": "card", className: cn("bg-card text-card-foreground grid grid-rows-[auto_1fr_auto] shrink-0 ", shadow && "shadow-sm", rounded && "rounded-xl", columns && gridColumns[columns], divide && "divide-x", bordered && "border", className) }, props)));
}
function CardHeader(_a) {
    var className = _a.className, _b = _a.borderBottom, borderBottom = _b === void 0 ? false : _b, props = __rest(_a, ["className", "borderBottom"]);
    return (_jsx("div", __assign({ "data-slot": "card-header", className: cn("@container/card-header relative grid auto-rows-min grid-rows-[auto_auto] items-start px-6 py-6 has-[data-slot=card-action]:grid-cols-[1fr_auto]", borderBottom && "border-b pb-5", className) }, props)));
}
function CardTitle(_a) {
    var className = _a.className, _b = _a.truncate, truncate = _b === void 0 ? false : _b, props = __rest(_a, ["className", "truncate"]);
    return _jsx("div", __assign({ "data-slot": "card-title", className: cn("text-lg font-semibold", truncate && "truncate", className) }, props));
}
function CardDescription(_a) {
    var className = _a.className, _b = _a.truncate, truncate = _b === void 0 ? false : _b, props = __rest(_a, ["className", "truncate"]);
    return _jsx("div", __assign({ "data-slot": "card-description", className: cn("text-muted-foreground text-sm", truncate && "truncate", className) }, props));
}
function CardAction(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx("div", __assign({ "data-slot": "card-action", className: cn("col-start-2 row-span-2 row-start-1 self-start justify-self-end", className) }, props)));
}
function CardContent(_a) {
    var className = _a.className, _b = _a.padded, padded = _b === void 0 ? true : _b, props = __rest(_a, ["className", "padded"]);
    return _jsx("div", __assign({ "data-slot": "card-content", className: cn(padded && "px-6 pb-6 pt-0", className) }, props));
}
function CardFooter(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return _jsx("div", __assign({ "data-slot": "card-footer", className: cn("flex items-center px-6 [.border-t]:pt-6", className) }, props));
}
var CardDecorator = function (_a) {
    var children = _a.children;
    return (_jsxs("div", { className: "relative mx-auto size-20 duration-200 [--color-border:color-mix(in_oklab,var(--color-zinc-950)20%,transparent)] group-hover:[--color-border:color-mix(in_oklab,var(--color-zinc-950)30%,transparent)]", children: [_jsx("div", { "aria-hidden": true, className: "absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:20px_20px]" }), _jsx("div", { "aria-hidden": true, className: "to-background absolute inset-0 bg-radial from-transparent to-80%" }), _jsx("div", { className: "bg-background absolute inset-0 m-auto flex size-10 p-2.5 items-center justify-center border-t border-l", children: children })] }));
};
function CardColumn(_a) {
    var className = _a.className, _b = _a.columnSpan, columnSpan = _b === void 0 ? 1 : _b, props = __rest(_a, ["className", "columnSpan"]);
    // List the possible options so these tailwind classes are included in the build
    var gridColspanOptions = {
        1: "col-span-1",
        2: "col-span-2",
        3: "col-span-3",
        4: "col-span-4",
        5: "col-span-5",
        6: "col-span-6",
        7: "col-span-7",
        8: "col-span-8",
        9: "col-span-9",
        10: "col-span-10",
        11: "col-span-11",
        12: "col-span-12",
    };
    return _jsx("div", __assign({ className: cn(gridColspanOptions[columnSpan], className) }, props));
}
export { Card, CardAction, CardColumn, CardContent, CardDecorator, CardDescription, CardFooter, CardHeader, CardTitle };
